import React from "react";
import { useParams } from "react-router-dom";
import ClientHeader from "~components/ClientInfo/ClientHeader";
import useCliente from "~/fetchs/useCliente";
import { useConfigureFooter } from "~hooks/useHelpers";
import EditarProdutoFormulario from "./EditarProdutoFormulario";

const EditarProduto = () => {
  useConfigureFooter({ form: true, formId: "formProduct", submitLabel: "Adicionar Produto", notDeveloped: false });

  const { parameter: idCliente } = useParams();
  const { cliente } = useCliente(idCliente);

  return (
    <>
      <ClientHeader dados={cliente} />
      <EditarProdutoFormulario />
    </>
  );
};

export default EditarProduto;
